import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";
import { LOGO } from "../../lib/content";

const field = "w-full rounded-xl border border-[#EBD08A] px-4 py-3.5 outline-none focus:border-[#FF1F8E]";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/account"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#0E0B0D] px-4">
      <form onSubmit={submit} className="stitch-box relative w-full max-w-md rounded-[2rem] bg-white p-8 sm:p-10" data-testid="admin-login-form">
        <img src={LOGO} alt="KMK Customs" className="mx-auto h-20" />
        <h1 className="mt-4 text-center font-display text-2xl font-bold">Owner login</h1>
        <div className="mt-8 space-y-4">
          <input type="email" required placeholder="Email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
          <input type="password" required placeholder="Password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
          {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
          <button disabled={busy} className="btn-pink w-full disabled:opacity-60" data-testid="admin-login-submit">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Log in"}
          </button>
        </div>
      </form>
    </div>
  );
}
